<template>
	<div :class="'static-card '+(className || '')">
		<a :href="url">
			<img :src="thumbnail" alt="Card" />
		</a>
	</div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'StaticCard',
		props: ['url','thumbnail','className'],
		data() {
			return {
				events: []
			}
		}
	}
</script>
<style scoped>
	.static-card {
		padding: 8px;
	}

	.static-card a, .static-card a img {
		width: 100%;
		height: auto;
		display: block;
	}
</style>